// extracted by mini-css-extract-plugin
export default {"Global":"Global_Global__lNyUL","PhoneLink":"Global_PhoneLink__TpQ0J"};